/* eslint-disable react/prop-types */
import React from 'react';
import classnames from 'classnames';
import { getBackgroundImg, MarkupRender } from '@nutastic/nutastic-react-app';

const PageHeader = ({ className, content, iconClass, image, title, subtitle }) => {
    const componentClass = 'pageHeader';
    const classes = classnames(componentClass, className);

    return <section className={classes}>
        <div className={`${componentClass}__image animated slideInLeft`} style={getBackgroundImg(image)} />
        <div className={`${componentClass}__details animated fadeIn delay-1s`}>
            <h5>{subtitle}</h5>
            <h1>{title}</h1>
            <div className="icon-divider icon-divider--withBlack icon-divider--large">
                <i className={iconClass} />
            </div>
            <MarkupRender tagName="p" content={content} />
        </div>
    </section>;
};

export default PageHeader;
